import { render, staticRenderFns } from "./TimedAlert.vue?vue&type=template&id=4586301f&"
import script from "./TimedAlert.vue?vue&type=script&lang=js&"
export * from "./TimedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports